import React from 'react';
import { TriangleAlert } from 'lucide-react';
import StatusBadge from '../StatusBadge/StatusBadge';
import { useI18n } from '../../i18n/I18nContext';
import './Student360.css';

// An enrollment with access is green everywhere in the CRM (clients, courses, here); "no access" is red.
const ENROLLMENT_TONE = { ACTIVE: 'success', COMPLETED: 'success', INACTIVE: 'danger' };
const ACCOUNT_TONE = { BANNED: 'danger', DISABLED: 'neutral' };

/** ACTIVE / COMPLETED / INACTIVE (no access) of one enrollment. */
export function EnrollmentBadge({ status }) {
  const { t } = useI18n();
  if (!ENROLLMENT_TONE[status]) return null;
  return (
    <StatusBadge tone={ENROLLMENT_TONE[status]}>{t(`student360.enrollment.${status}`)}</StatusBadge>
  );
}

/** Shown only for a banned or disabled account; a normal account has no badge. */
export function AccountStatusBadge({ status }) {
  const { t } = useI18n();
  if (!ACCOUNT_TONE[status]) return null;
  return (
    <StatusBadge tone={ACCOUNT_TONE[status]}>{t(`student360.account.${status}`)}</StatusBadge>
  );
}

/** The new presence rule: an active enrollment and not seen for 7 days or more. */
export function AtRiskChip() {
  const { t } = useI18n();
  return (
    <span className="s360-risk" title={t('student360.atRiskHint')}>
      <StatusBadge tone="danger">
        <TriangleAlert size={12} aria-hidden="true" />
        {t('student360.atRisk')}
      </StatusBadge>
    </span>
  );
}
